import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
/**
 * ECD Services Component
 */
let EcdServicesComponent = class EcdServicesComponent {
    constructor() {
    }
    ngOnInit() {
    }
};
EcdServicesComponent = __decorate([
    Component({
        selector: 'ecd-engl-services',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./ecd-services.component.html")).default
    })
], EcdServicesComponent);
export { EcdServicesComponent };
